<template>
  <footer class="footer">
    <div class="container-fluid"></div>
    <div class="container-fluid">
      <div class="container clearFix">
        <div class="footer-right">
          <h4 class="footer-right-title">技术与解决方案</h4>
          <ul>
            <li><a href="#">水污染防治</a></li>
            <li><a href="#">大气污染防治</a></li>
            <li><a href="#">噪声污染防治</a></li>
            <li><a href="#">矿山整治与修复</a></li>
            <li><a href="#">固废处置</a></li>
            <li><a href="#">农村综合整治</a></li>
          </ul>
          <ul>
            <li><a href="#">污染设施运营</a></li>
            <li><a href="#">河湖生态修复与重建</a></li>
            <li><a href="#">污水厂尾水深度净化</a></li>
            <li><a href="#">污染河水生态净化</a></li>
          </ul>
          <ul>
            <li><a href="#">污染源调查</a></li>
            <li><a href="#">入河排污口调查</a></li>
            <li><a href="#">黑臭水体评估</a></li>
            <li><a href="#">环保顾问服务</a></li>
            <li><a href="#">环保环境风险管理与场地风险评估顾问服务</a></li>
          </ul>
        </div>
        <div class="footer-left">
          <div class="footer-icon">
            <i></i>
            <br />
            <span>更多精彩请关注</span>
          </div>
          <ul>
            <li>
              <span>地址：</span>
              <span>广州市越秀区东华东路682-684号</span>
            </li>
            <li>
              <span>电话：</span>
              <span>020-83321284</span>
            </li>
            <li>
              <span>邮箱：</span>
              <span>hkep@scies.com.cn</span>
            </li>
            <li>
              <span>网址：</span>
              <span>
                <a href="http://www.hk-ep.com.cn/home" target="_blank">
                  http://www.hk-ep.com.cn/home
                </a>
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div class="footer-copyright">
        版权所有：广州华科环保工程有限公司 ICP备案编号：粤ICP备06005976号
      </div>
    </div>
  </footer>
</template>
<style lang="less">
@import url("./css/footer.less");
</style>
